/* formCheck(formClassName, formInputWErrorWrapClassNames)
 *
 * @params {string} formClassName submitを制御する対象のformのクラス名
 * @params {Array(string)} formInputWErrorWrapClassNames エラーを検出するinput(js-login-form-input) と そのテキスト js-login-form-errorのラッパー
*/

const fetchElements = (formClassName, formInputWErrorWrapClassNames) => {
  const $form = document.querySelector(`.${formClassName}`);
  const $inputErrorWraps = formInputWErrorWrapClassNames.map(wrapClassName => {
    return {
      input: document.querySelector(`.${wrapClassName} .js-login-form-input`),
      error: document.querySelector(`.${wrapClassName} .js-login-form-error`)
    };
  });
  return [$form, $inputErrorWraps];
};

const isInputEmpty = (input) => {
  return input.value.length > 0;
};

const toggleActiveErrorElement = ({ input, error }) => {
  input.classList.toggle('js-error', isInputEmpty(input));
  error.classList.toggle('js-error', isInputEmpty(input));
};

const inputsEventHandler = ($wrap) => {
  $wrap.input.addEventListener('keyup', () => toggleActiveErrorElement($wrap));
};

const formEventHandler = ($form, $inputErrorWraps) => {
  $form.addEventListener('submit', (e) => {
    const $errorWraps = $inputErrorWraps.filter($wrap => {
      return isInputEmpty($wrap.input);
    });
    if ($errorWraps.length > 0) {
      $errorWraps.forEach($wrap => {
        toggleActiveErrorElement($wrap);
        inputsEventHandler($wrap);
      });
      e.preventDefault();
    } else {
      $form.submit();
    }
  });
};

const isFormElementsExists = ($form, $inputErrorWraps) => {
  return $inputErrorWraps.reduce((flg, $currentElements) => {
    return $currentElements.input !== null && $currentElements.error !== null && flg;
  }, true) && $form !== null;
};

const formCheck = (formClassName, formInputWErrorWrapClassName) => {
  const [$form, $inputErrorWraps] = fetchElements(formClassName, formInputWErrorWrapClassName);
  if (isFormElementsExists($form, $inputErrorWraps)) {
    formEventHandler($form, $inputErrorWraps);
  }
};

export default formCheck;
